import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
// actions
import actionListaIntegracoesByCliente from 'src/actions/clientes/actionListaIntegracoesByCliente';
import actionEditarIntegracao from 'src/actions/clientes/actionEditarIntegracao';
// components
import ModalChatGpt from './Modals/ModalChatGpt';
import SettingIntegration from './SettingIntegration';

// ----------------------------------------------------------------------

const DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1",
        },
    },
};

MainIntegracoes.propTypes = {
    cliente: PropTypes.object,
};

export default function MainIntegracoes({ cliente }) {
    const navigate = useNavigate();
    const [modalChatGpt, setModalChatGpt] = useState(false);
    const [integracaoIdChatgpt, setIntegracaoIdChatgpt] = useState('');
    const [tipoIntrucaoChatGpt, setTipoIntrucaoChatGpt] = useState('');
    const [chatGptStatus, setChatGptStatus] = useState(false);
    const [instrucaoChatgpt, setInstrucaoChatgpt] = useState('');
    const [chatGptApiKey, setChatGptApiKey] = useState('');
    const [chatGptOrganizationKey, setChatGptOrganizationKey] = useState('');

    const buscarListaIntegracoesByCliente = async () => {
        try {
            const response = await actionListaIntegracoesByCliente(cliente._id);
            if (response.data && response.data.data.length > 0) {
                if (response.data.data.some((item) => item.resource === "chatgpt")) {
                    let dadosFiltrados = response.data.data.filter((item) => item.resource === "chatgpt")[0];
                    setIntegracaoIdChatgpt(dadosFiltrados._id);
                    setInstrucaoChatgpt(dadosFiltrados.config.instrucao);
                    setTipoIntrucaoChatGpt(dadosFiltrados.config.tipo_instrucao);
                    setChatGptApiKey(dadosFiltrados.config.keys.LAIS_OPENAI_API_KEY);
                    setChatGptOrganizationKey(dadosFiltrados.config.keys.LAIS_ORGANIZATION);
                    setChatGptStatus(dadosFiltrados.status);
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const editarConfigChatGpt = async () => {
        try {
            let data = {
                scope: {
                    clienteId: cliente._id,
                    status: chatGptStatus,
                    chatGptApiKey: chatGptApiKey,
                    chatGptOrganizationKey: chatGptOrganizationKey,
                    tipoInstrucao: tipoIntrucaoChatGpt,
                    intrucao: instrucaoChatgpt,
                },
                action: "editar_chatgpt",
            };
            await actionEditarIntegracao(integracaoIdChatgpt, data);
            buscarListaIntegracoesByCliente();
            setModalChatGpt(false);
        } catch (error) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        buscarListaIntegracoesByCliente();
    }, []);

    return (
        <div className={DESIGN.page.container}>
            {/* Header */}
            <div className={DESIGN.page.header.container}>
                <div>
                    <h1 className={DESIGN.page.header.title}>Integrações</h1>
                    <p className={DESIGN.page.header.subtitle}>
                        Aqui você pode configurar as integrações com os canais de comunicação, webhooks e API.
                    </p>
                </div>
            </div>

            <ModalChatGpt
                onSubmit={editarConfigChatGpt}
                open={modalChatGpt}
                chatGptStatus={chatGptStatus}
                changeStatusIntegracao={(e) => setChatGptStatus(e.target.checked)}
                changeChatGptApiKey={(e) => setChatGptApiKey(e.target.value)}
                changeChatGptOrganizationKey={(e) => setChatGptOrganizationKey(e.target.value)}
                chatGptApiKey={chatGptApiKey}
                chatGptOrganizationKey={chatGptOrganizationKey}
                onClose={() => setModalChatGpt(false)}
                tipoIntrucaoChatGpt={tipoIntrucaoChatGpt}
                instrucaoChatgpt={instrucaoChatgpt}
                changeInstrucaoChatgpt={(e) => setInstrucaoChatgpt(e.target.value)}
                changeTipoIntrucaoChatGpt={(e) => {
                    setTipoIntrucaoChatGpt(e.target.value);
                }}
            />

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <SettingIntegration />
            </div>
        </div>
    );
}